export const dominantArmTwObjs = [
  { label: '右投', value: 'rightThrow' },
  { label: '左投', value: 'leftThrow' }
]

export const sizeTwObjs = [
  { label: '加長10mm', value: 'large10', price: 3300 },
  { label: '加長5mm', value: 'large5', price: 3300 },
  { label: '標準尺寸', value: 'default', price: 0 },
  { label: '縮小5mm', value: 'small5', price: 3300 },
  { label: '縮小10mm', value: 'small10', price: 3300 }
]

export const backLaceTwObjs = [
  { label: '直線', value: 'straight', imageUrl: '/atoms/baseSettings/backLace/exist.jpg' },
  { label: '無', value: 'none', imageUrl: '/atoms/baseSettings/backLace/none.jpg' }
]

export const backStyleTwObjs = [
  { label: '正常背帶', value: 'beltBackStyle', imageUrl: '/atoms/baseSettings/backStyle/glove/regular.jpg' }, // グラブ
  { label: '封閉式', value: 'firstBackStyle', imageUrl: '/atoms/baseSettings/backStyle/glove/firstBack.jpg' },
  { label: '皇冠', value: 'crownBackStyle', imageUrl: '/atoms/baseSettings/backStyle/glove/crownBack.jpg' },
  { label: '開放式', value: 'beltBackStyleCatcher', imageUrl: '/atoms/baseSettings/backStyle/catcherMitt/belt.jpg' },
  { label: '封閉式(捕手)', value: 'regularBackStyleCatcher', imageUrl: '/atoms/baseSettings/backStyle/catcherMitt/regular.jpg' }
]

export const backStyleForPitcherTwObjs = [
  { label: '正常背帶', value: 'beltBackStyle', imageUrl: '/atoms/baseSettings/backStyle/glove/regular.jpg' }, // グラブ
  { label: '封閉式', value: 'firstBackStyle', imageUrl: '/atoms/baseSettings/backStyle/glove/firstBack.jpg' },
  { label: '皇冠', value: 'crownBackStyle', imageUrl: '/atoms/baseSettings/backStyle/glove/crownBack.jpg' }
]

export const backStyleForCatcherMittTwObjs = [
  { label: '開放式', value: 'beltBackStyleCatcher', imageUrl: '/atoms/baseSettings/backStyle/catcherMitt/belt.jpg' },
  { label: '封閉式(捕手)', value: 'regularBackStyleCatcher', imageUrl: '/atoms/baseSettings/backStyle/catcherMitt/regular.jpg' }
]

export const fingerGuardTypeAllTwObjects = [
  { label: '護指套(食指)', value: 'indexCover', imageUrl: '/atoms/baseSettings/fingerGuardType/indexCover.jpg' },
  { label: '護指套(中指)', value: 'middleCover', imageUrl: '/atoms/baseSettings/fingerGuardType/middleCover.jpg' },
  { label: '指片(食指)', value: 'indexPad', imageUrl: '/atoms/baseSettings/fingerGuardType/indexPad.jpg' },
  { label: '指片(中指)', value: 'middlePad', imageUrl: '/atoms/baseSettings/fingerGuardType/middlePad.jpg' },
  { label: '無', value: 'none', imageUrl: '/atoms/baseSettings/fingerGuardType/none.jpg' }
]

export const fingerGuardTypeTwObjs = [
  { label: '護指套(食指)', value: 'indexCover', imageUrl: '/atoms/baseSettings/fingerGuardType/indexCover.jpg' },
  { label: '指片(食指)', value: 'indexPad', imageUrl: '/atoms/baseSettings/fingerGuardType/indexPad.jpg' },
  { label: '無', value: 'none', imageUrl: '/atoms/baseSettings/fingerGuardType/none.jpg' }
]

export const fingerGuardForFirstMittTwObjs = [
  { label: '指片(食指)', value: 'indexPad', imageUrl: '/atoms/baseSettings/fingerGuardType/indexPad.jpg' },
  { label: '無', value: 'none', imageUrl: '/atoms/baseSettings/fingerGuardType/none.jpg' }
]

export const fingerGuardTypeForOutfielderTwObjs = fingerGuardTypeAllTwObjects

export const materialPackTwObjs = [
  { label: '直蕊', value: 'vertical', imageUrl: '/atoms/baseSettings/materialPack/vertical.jpg' },
  { label: '正常', value: 'sideDouble', imageUrl: '/atoms/baseSettings/materialPack/sideDouble.jpg' }
]

export const moldingTwObjs = [
  { label: '要', value: 'moldingProcess', price: 8800 },
  { label: '不要', value: 'none', price: 0 }
]

export const loopOfRingFingerTwObjs = [
  { label: '有', value: 'loopOfRingFinger', price: 4620, imageUrl: '/atoms/baseSettings/loopOfFinger/exist.jpg' },
  { label: '無', value: 'none', price: 0, imageUrl: '/atoms/baseSettings/loopOfFinger/none.jpg' }
]

export const printLeatherTypeTwObjs = [
  { label: '藍色迷彩', value: 'blueCamo', price: 22000 },
  { label: '綠色迷彩', value: 'greenCamo', price: 22000 },
  { label: '藍色銀河', value: 'blueGalaxy', price: 22000 },
  { label: '粉色銀河', value: 'pinkGalaxy', price: 22000 },
  { label: '無', value: 'none', price: 0 }
]

export const tw2JaBasePartsTranslates = [
  // 共通
  { taiwan: '無', japanese: 'なし' },
  { taiwan: '不要', japanese: 'なし' },
  { taiwan: '有', japanese: 'あり' },
  { taiwan: '要', japanese: 'あり' },

  // 種別
  { taiwan: '種別', japanese: '種別' },
  // タンナー USモデル
  { taiwan: '美國成牛', japanese: 'US Leather' },

  // タンナー 日本モデル
  { taiwan: '歐洲牛皮', japanese: 'European Steer Leather' },
  { taiwan: '北海道成牛', japanese: 'North Steer Leather' },
  { taiwan: '成牛皮', japanese: 'Steer Leather' },

  // 芯トジ
  { taiwan: '直蕊', japanese: '縦とじ' },
  { taiwan: '正常', japanese: '横とじ' },

  // 利き腕
  { taiwan: '右投', japanese: '右投げ' },
  { taiwan: '左投', japanese: '左投げ' },

  // ウェブ
  { taiwan: '球擋上', japanese: 'ウェブ' },
  { taiwan: '球擋', japanese: 'ウェブ' },

  // 背面紐スタイル
  { taiwan: '直線', japanese: 'ストレート' },
  { taiwan: '背帶', japanese: 'バックレース' },

  // サイズ
  { taiwan: '加長10mm', japanese: '10mm大きく' },
  { taiwan: '加長5mm', japanese: '5mm大きく' },
  { taiwan: '標準尺寸', japanese: '基本モデルズバリ' },
  { taiwan: '縮小5mm', japanese: '5mm小さく' },
  { taiwan: '縮小10mm', japanese: '10mm小さく' },
  { taiwan: '尺寸', japanese: 'サイズ' },

  // 指カバー
  { taiwan: '護指套(食指)', japanese: '指カバー(人差指)' },
  { taiwan: '護指套(中指)', japanese: '指カバー(中指)' },
  { taiwan: '指片(食指)', japanese: '指アテ(人差指)' },
  { taiwan: '指片(中指)', japanese: '指アテ(中指)' },

  // バックスタイル
  { taiwan: '正常背帶', japanese: 'レギュラー' },
  { taiwan: '封閉式', japanese: 'ファーストバック' },
  { taiwan: '皇冠', japanese: 'ウィングチップ' },
  // キャッチャーミットバックスタイル
  { taiwan: '開放式', japanese: 'ベルト' }, // 捕手 / バックスタイル
  { taiwan: '封閉式(捕手)', japanese: 'レギュラーバック' }, // 捕手 / バックスタイル

  // プリントレザー
  { taiwan: '藍色迷彩', japanese: 'ブルーカモ' },
  { taiwan: '綠色迷彩', japanese: 'グリーンカモ' },
  { taiwan: '藍色銀河', japanese: 'ブルーギャラクシー' },
  { taiwan: '粉色銀河', japanese: 'ピンクギャラクシー' },

  // ※別の場所に定義すべきな気がする
  { taiwan: '投手', japanese: '投手' },
  { taiwan: '捕手', japanese: '捕手' },
  { taiwan: '一壘手', japanese: '一塁手' },
  { taiwan: '二壘手', japanese: '二塁手' },
  { taiwan: '三壘手', japanese: '三塁手' },
  { taiwan: '遊擊手', japanese: '遊撃手' },
  { taiwan: '左翼手', japanese: '左翼手' },
  { taiwan: '中堅手', japanese: '中堅手' },
  { taiwan: '右翼手', japanese: '右翼手' },
  { taiwan: '外野手', japanese: '外野手' }
]
